import { Button, Card, TextField } from "@mui/material";
import { styled } from "styled-components";
import { deviceSpec } from "breakpoints";


// The overall RagDad container
export const RagDadContainer = styled('div')`
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    width: 100%;
`

// The options container
export const RagDadOptionsWrapper = styled('div')`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 1em;

    .MuiTabs-flexContainer {
        justify-content: space-between;
    }

    .MuiInputBase-root, .MuiButtonBase-root {
        height: auto !important;
    }
    
    .MuiButton-root {
        align-items: start;
        padding: 0.5em;
        border: 2px solid ${({theme}) => theme.colors.lightGreyRgba} !important;
        opacity: 0.8;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .MuiButton-root:hover {
        background-color: ${({theme}) => theme.colors.lightGrey} !important;
    }
`

export const RagDadChildComponentWrapper = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;

    label {
        font-size: ${({theme}) => theme.font.large} !important;
    }

    @media ${deviceSpec.isMobile} {
        align-items: baseline;
        margin-top: 4em;
    }
`

// Individual option
export const RagDadOption = styled(Button)`
    padding: 1em;
    display: flex;
    flex-direction: column;
    align-items: start;

    svg {
        opacity: 0.8;
    }

    p {
        text-align: left;
        word-break: normal;
    }
`

export const OptionData = styled('div')`
    div {
        width: 30px;
        height: 30px;
        opacity: 0;
    }
`

export const UploadUploadContainer = styled(Card)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    border: 2px dashed rgba(85, 85, 85, .2);
    border-radius: 10px !important;
    width: 75%;
    margin: 0;
    background-color: rgba(85, 85, 85, 0) !important;
    padding: 2em;

    div {
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    p {
        opacity: 0.8;
    }

    svg {
        font-size: 5em;
    }
`

export const MultilineText = styled(TextField)`
    .MuiFormLabel-root {
        top: 0;
    }

    .MuiInputBase-root {    
        height: auto !important;
    }
    
    height: auto !important;
`

export const UploadContainer = styled('div')`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 2em 0;
`
export const UploadFilesContainer = styled('div')`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 2em 0;

    p {
        font-size: ${({theme}) => theme.font.xl};
        opacity: 0.8;
    }

    ul {
        list-style: none;
        color: ${({theme}) => theme.colors.textColor};
        opacity: 0.8;
    }
`

export const DeleteDocumentContainer = styled('div')`
    .MuiButtonBase-root {
        background-color: ${({theme}) => theme.colors.highlight4};
        color: black;
        font-weight: 500;
    }
`

export const SearchDocumentContainer = styled('div')`
    width: 50%;
    .MuiButtonBase-root {
        color: black;
        font-weight: 500;
    }
`

export const CreateDocumentContainer = styled('div')`
    .MuiTypography-root {
        opacity: 0.9;
        color: ${({theme}) => theme.colors.textColor};
    }
    
    width: 50%;

    @media ${deviceSpec.isTablet} {
        width: 80%;
    }

    @media ${deviceSpec.isMobile} {
        width: 100%;
    }
`

export const FetchIndicesHeader = styled(Card)`
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
`

export const FetchIndiciesContainer = styled('div')`
    width: 100%;
`

export const DataTableGridItem = styled('div')`
    display: flex;
    justify-content: space-between;

    p {
        display: flex;
        align-items: center;
    }

    .loading {
        -webkit-animation:spin 0.5s linear infinite;
        -moz-animation:spin 0.5s linear infinite;
        animation:spin 0.5s linear infinite;

        @-moz-keyframes spin { 
            100% { -moz-transform: rotate(360deg); } 
        }
        @-webkit-keyframes spin { 
            100% { -webkit-transform: rotate(360deg); } 
        }
        @keyframes spin { 
            100% { 
                -webkit-transform: rotate(360deg); 
                transform:rotate(360deg); 
            } 
        }
    }

    .round {
        border-radius: 100%;
        width: 24px;
        height: 24px !important;
        min-width: 24px;
        padding: 0;
        border-radius: 100%;
        // color: white;
    }
`